@if (linkExpired) {
    <af-recovery-status iconType="expired"
                        titleText="i18n_af_resetPasswordExpiredTitle"
                        subtitleText="i18n_af_resetPasswordExpiredSubtitle"/>
} @else if (passwordReset) {
    <af-recovery-status iconType="success"
                        titleText="i18n_af_resetPasswordSuccessTitle"
                        subtitleText="i18n_af_resetPasswordSuccessSubtitle"/>
} @else if (tokenChecked) {
    <div class="reset-viewport w-100 bc-mono-white b-logo" fxLayout="column">
        <div fxLayout="column" fxLayoutAlign="start center" class="reset-center w-100">
            <div fxLayout="column" fxLayoutAlign="start stretch"
                 class="reset-card p-32 main-shadow radius-16">
                <div class="h3-semi-bold c-primary-gray-900 text-center pre-line">
                    {{ 'i18n_af_resetPasswordTitle' | translate }}
                </div>
                <form [formGroup]="form"
                      (submit)="submit()"
                      fxLayout="column"
                      fxLayoutAlign="start stretch"
                      class="mt-24"
                      autocomplete="off">
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelNewPassword' | translate }}</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.controls.newPassword.value">
                            <input matInput
                                   formControlName="newPassword"
                                   name="newPassword"
                                   [maxlength]="maxLength"
                                   [placeholder]="'i18n_af_placeholderNewPassword' | translate"
                                   [type]="showNewPassword ? 'text' : 'password'"/>
                            <ui-kit-svg matRipple
                                        matSuffix
                                        class="i-24 circle pointer p-8 c-primary-green-900"
                                        [name]="showNewPassword ? 'ic_eye_show' : 'ic_eye_hide'"
                                        (click)="showNewPassword = !showNewPassword"/>
                        </mat-form-field>
                        <af-password-requirements class="w-100 mt-8" [password]="form.controls.newPassword.value"/>
                        @if (serverValidationFailed) {
                            <div class="t5 c-secondary-red-800">
                                {{ 'i18n_af_errorPasswordHistory' | translate }}
                            </div>
                        }
                    </div>
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-100 mt-24">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelConfirmPassword' | translate }}</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.controls.confirmPassword.value">
                            <input matInput
                                   formControlName="confirmPassword"
                                   name="confirmPassword"
                                   [maxlength]="maxLength"
                                   [placeholder]="'i18n_af_placeholderConfirmPassword' | translate"
                                   [type]="showConfirmPassword ? 'text' : 'password'"/>
                            <ui-kit-svg matRipple
                                        matSuffix
                                        class="i-24 circle pointer p-8 c-primary-green-900"
                                        [name]="showConfirmPassword ? 'ic_eye_show' : 'ic_eye_hide'"
                                        (click)="showConfirmPassword = !showConfirmPassword"/>
                        </mat-form-field>
                        @if (form.controls.confirmPassword.value && form.controls.confirmPassword.touched
                            && (form.hasError('passwordsMismatch') || form.controls.confirmPassword.hasError('passwordsMismatch'))) {
                            <div class="t5 c-secondary-red-800">{{ 'i18n_af_errorPasswordMismatch' | translate }}</div>
                        }
                    </div>
                    <div fxLayout="column" fxLayoutAlign="center center" class="mt-32">
                        <ui-kit-button [disabled]="form.invalid"
                                       type="primary"
                                       spinnerId="submit"
                                       label="{{ 'i18n_af_buttonSave' | translate }}"/>
                        <ui-kit-button class="mt-16"
                                       type="text"
                                       buttonType="button"
                                       color="accent"
                                       (clickListener)="cancel()"
                                       label="{{ 'i18n_af_buttonCancel' | translate }}"/>
                    </div>
                </form>
            </div>
        </div>
    </div>
}
